// extracted by mini-css-extract-plugin
export default {"page-container":"styles_page-container__Ayswk","content-container":"styles_content-container__DtBWG","hrline":"styles_hrline__4ugQ4","vrgap":"styles_vrgap__Z06s6"};